export default __webpack_public_path__ + "static/media/animalfacts.a03427af.png";